module.exports = __webpack_public_path__ + "homeStatic/img/img01.48f590d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/circle/img01.png
// module id = im4s
// module chunks = 1